module.exports = __webpack_public_path__ + "static/media/w3w.544c68b8.svg";